module.exports = __webpack_public_path__ + "449cb1d6e6cced62d068bc0e1a5859d0.svg";